module.exports = __webpack_public_path__ + "static/media/unselectedDragAndDrop.a3b6033c.png";